module.exports = __webpack_public_path__ + "static/img/portafolioDisenoMosaikus.f80d688.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/portfolioDesign/portafolioDisenoMosaikus.webp
// module id = 478
// module chunks = 1